module.exports = __webpack_public_path__ + "img/1f9f6.9295027.svg";